import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { RecommendationModel } from 'Pages/orders'

export type RecommendationsState = {
	recommendations: ResponseCatalog<RecommendationModel>
	requestParams: RequestParams
}

export const recommendationsInitialState: RecommendationsState = {
	recommendations: new ResponseCatalog<RecommendationModel>(),
	requestParams: new RequestParams(1, 50),
}

export namespace RecommendationsNS {
	export type getAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: () => void
		errorCallback?: (errors?: unknown) => void
	}>
	export type setAll = PayloadAction<ResponseCatalog<RecommendationModel>>
	export type setRequestParams = PayloadAction<RequestParams>
	export type updateOne = PayloadAction<{ recommendation: RecommendationModel; id?: number }>
	export type deleteOne = PayloadAction<number>
	export type clearAll = PayloadAction
}

export const recommendationsSlice = createSlice({
	name: 'recommendations',
	initialState: recommendationsInitialState,
	reducers: {
		getAll: (state, action: RecommendationsNS.getAll) => {},
		setAll: (state, action: RecommendationsNS.setAll) => {
			state.recommendations = action.payload
		},
		setRequestParams: (state, action: RecommendationsNS.setRequestParams) => {
			state.requestParams = action.payload
		},
		updateOne: (state, action: RecommendationsNS.updateOne) => {},
		deleteOne: (state, action: RecommendationsNS.deleteOne) => {},
		clearAll: (state, action: RecommendationsNS.clearAll) => {
			state.recommendations = new ResponseCatalog<RecommendationModel>()
		},
	},
})
